import React, { useEffect, useState } from "react";
import DeleteAuthenticator from "./deleteAuthenticator";
import NewOtpAuthenticator from "./newOtpAuthenticator";
import { ToastsStore } from "react-toasts";
import axios from "axios";
import { connect } from "react-redux";
import settings from "client.settings.json";
import { setUser, setAuthenticatorSource } from "reducers/user";
import { translate } from "reducers/i18n";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

const { api } = settings;

const Authenticators = () => {
  const dispatch = useDispatch();
  const { messageId, tenantId } = useParams();
  const [authenticators, setAuthenticators] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    try {
      if (messageId) {
        axios.post(`${api}/api/login/authenticators`, { messageId, tenantId }).then(res => {
          const { authenticators, username, authenticatorSource = "unknown" } = res.data;
          setAuthenticators(authenticators);
          dispatch(setUser(username));
          dispatch(setAuthenticatorSource(authenticatorSource));
        });
      }
    } catch (error) {
      console.error(error);
    }
  }, [messageId]);

  const handleSubmit = async ({ name, secret, token }) => {
    try {
      setIsSubmitting(true);
      const data = { messageId, name, secret, token };
      const res = await axios.post(`${api}/api/login/authenticator`, data);
      setAuthenticators(res.data);
      ToastsStore.success(translate("authenticator_added"));
    } catch (error) {
      console.log(error);
      throw error;
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="panel">
      <div className="panelHeader header_fontFamily">
        <h1>{translate("login_methods")}</h1>
      </div>
      <div className="panelContent body_fontFamily">
        <div className="panelProps authenticators">
          <div className="row panelPropRow">
            <div className="col">
              <ul className="list-group">
                {authenticators.map(({ _id: authId, name, publicValue, type }) => (
                  <li key={authId} className="list-group-item d-flex align-items-center flex-wrap">
                    <span
                      className={`badge badge-${
                        type === "otp" ? "secondary" : "primary"
                      } badge-pill text-uppercase mr-3`}
                    >
                      {type === "phoneNumber" ? "sms" : type}
                    </span>
                    <span className="mr-2">
                      {publicValue} {name ? <span className="text-muted">({name})</span> : null}
                    </span>
                    {type === "otp" ? (
                      <DeleteAuthenticator authId={authId} setAuthenticators={setAuthenticators} />
                    ) : null}
                  </li>
                ))}
                <NewOtpAuthenticator handleSubmit={handleSubmit} isSubmitting={isSubmitting} />
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="panelFooter buttons_fontFamily">
        <div className="messageFooter "></div>
      </div>
    </div>
  );
};

const mapStateToProps = state => state.i18n;
export default connect(mapStateToProps)(Authenticators);
